/* eslint-disable no-console */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

const loadSpecialBuyPage = () => import(
  /* webpackChunkName: "special-buy-page" */
  './pages/SpecialBuyPage'
);

const loadSpecialBuyPagePerf = () => import(
  /* webpackChunkName: "special-buy-page-perf" */
  './pages/SpecialBuyPagePerf'
);

const createSpecialBuyRoute = (
  path,
  currentRouteName,
  currentRouteComponent,
  usePerf
) => {

  // console.log('currentRouteName:', currentRouteName, 'usePerf:', usePerf);

  if (usePerf) {
    return {
      name: 'special-buy-page-perf',
      componentName: 'SpecialBuyPagePerf',
      chunk: loadSpecialBuyPagePerf,
      get component() {
        return ssr
          ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SpecialBuyPagePerf.js')).SpecialBuyPagePerf
          : currentRouteName === 'special-buy-page-perf'
            ? currentRouteComponent
            : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SpecialBuyPagePerf })));
      },
      path,
      channel: null,
      varnish: true
    };
  }

  return {
    name: 'special-buy-page',
    componentName: 'SpecialBuyPage',
    chunk: loadSpecialBuyPage,
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SpecialBuyPage.js')).SpecialBuyPage
        : currentRouteName === 'special-buy-page'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SpecialBuyPage })));
    },
    path,
    channel: null,
    varnish: true
  };
};

const shouldUsePerf = (requestData) => {
  try {
    const { isConsumerApp, path, queryParams = {} } = requestData || {};
    if (isConsumerApp || (queryParams?.perf || path?.includes('perf=true'))) {
      return true;
    }
  } catch (err) {
    console.error(err);
  }
  return false;
};

export const getRoutes = (currentRouteName, currentRouteComponent, requestData) => {
  const usePerf = shouldUsePerf(requestData);
  return {
    sbotd: createSpecialBuyRoute(
      '/:context?/SpecialBuy/SpecialBuyOfTheDay', currentRouteName, currentRouteComponent, usePerf
    ),
    dailyDeals: createSpecialBuyRoute(
      '/:context?/daily-deals', currentRouteName, currentRouteComponent, usePerf
    ),
    pro: createSpecialBuyRoute(
      '/:context?/SpecialBuy/ProSpecialBuyOfTheWeek', currentRouteName, currentRouteComponent, usePerf
    )
  };
};

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};